module.exports = __webpack_public_path__ + "static/media/right-arrow.92f1ae69.svg";